export const blockIconsCommunicationKey = (
	<span className='material-symbols-outlined'>key</span>
);
